module.exports = __webpack_public_path__ + "static/img/WechatPrompt_3.53781084.png";